export default "__VITE_ASSET__ea0cb2b6__"